import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../core/domain/events/domain_event_provider';
import { NewsEvent } from './news-events';

@Injectable({ providedIn: 'root' })
export class NewsEventProvider extends DomainEventProvider<NewsEvent> {}
